<script setup>
const props = defineProps({
  loading: { type: Boolean, required: true },
});
</script>

<template>
  <div v-if="props.loading" data-qa="main-loader" class="loader loader-overlay">
    <div class="square"></div>
    <div class="square"></div>
    <div class="square"></div>
    <div class="square"></div>
  </div>
</template>

<style scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 9999;
}

.loader {
  display: flex;
  gap: 20px;
}

.square {
  width: 1.87rem;
  height: 1.87rem;
  background-color: #1c3d6e;
  animation: rotateColors 1s infinite ease-in-out;
}

.square:nth-child(2) {
  animation-delay: 0.2s;
  background-color: #4a90e2;
}

.square:nth-child(3) {
  animation-delay: 0.4s;
  background-color: #b0b7c3;
}

.square:nth-child(4) {
  animation-delay: 0.6s;
  background-color: #82a0c1;
}

@keyframes rotateColors {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}
</style>
